import { render, staticRenderFns } from "./ArchivedOrderItem.vue?vue&type=template&id=14d43d3a&scoped=true&"
import script from "./ArchivedOrderItem.vue?vue&type=script&lang=js&"
export * from "./ArchivedOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedOrderItem.vue?vue&type=style&index=0&id=14d43d3a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d43d3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VSpacer,VToolbar})
